export default "__VITE_ASSET__BPR5Odiw__"